import apiBase from "../../api/axios";

export const startQuizSessionService = async () => {
  const response = await apiBase.post("v1/evaluacion/sesiones-evaluacion/");
  return response.data;
};

export const getNextQuestionService = async (sessionId) => {
  const response = await apiBase.get(
    `v1/evaluacion/sesiones-evaluacion/${sessionId}/siguiente_pregunta/`,
  );

  return response.data;
};

export const sendAnswerService = async (payload) => {
  const response = await apiBase.post(
    "v1/evaluacion/respuestas-evaluacion/",
    payload,
  );
  return response.data;
};

export const getQuizPhaseService = async () => {
  const response = await apiBase.get(
    "v1/evaluacion/sesiones-evaluacion/ver_fase/",
  );
  return response.data;
};

// ── Helpers ─────────────────────────────────────────────────────────────────
// kind: 'tutorial' (video de bienvenida) | 'instrucciones' (video de instrucciones)
const fieldFile = (kind) =>
  kind === "instrucciones" ? "video_instrucciones" : "video_tutorial";
const fieldUrl = (kind) =>
  kind === "instrucciones" ? "video_instrucciones_url" : "video_tutorial_url";

// ── Video tutorial de inicio del quiz (configuración GLOBAL) ────────────────

export const getVideoTutorialInicioQuizService = async () => {
  const response = await apiBase.get("v1/video-tutorial-inicio-quiz/");
  return response.data;
};

export const putVideoTutorialInicioQuizFileService = async (
  file,
  kind = "tutorial",
) => {
  const formData = new FormData();
  formData.append(fieldFile(kind), file);
  formData.append("kind", kind);

  const response = await apiBase.put(
    "v1/video-tutorial-inicio-quiz/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const putVideoTutorialInicioQuizUrlService = async (
  url,
  kind = "tutorial",
) => {
  const response = await apiBase.put("v1/video-tutorial-inicio-quiz/", {
    [fieldUrl(kind)]: url,
    kind,
  });
  return response.data;
};

export const deleteVideoTutorialInicioQuizService = async (
  kind = "tutorial",
) => {
  const response = await apiBase.delete(
    `v1/video-tutorial-inicio-quiz/?kind=${kind}`,
  );
  return response.data;
};

// ── Tutoriales por módulo (MediaTutorial) ──────────────────────────────────

export const getMediaTutorialService = async (tipo) => {
  const response = await apiBase.get(`v1/media/tutoriales/?tipo=${tipo}`);
  return response.data;
};

export const postMediaTutorialFileService = async (
  tipo,
  nombre,
  file,
  kind = "tutorial",
) => {
  const formData = new FormData();
  formData.append("tipo", tipo);
  formData.append("nombre", nombre);
  formData.append("kind", kind);
  formData.append(fieldFile(kind), file);
  const response = await apiBase.post("v1/media/tutoriales/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const postMediaTutorialUrlService = async (
  tipo,
  nombre,
  url,
  kind = "tutorial",
) => {
  const response = await apiBase.post("v1/media/tutoriales/", {
    tipo,
    nombre,
    kind,
    [fieldUrl(kind)]: url,
  });
  return response.data;
};

export const patchMediaTutorialFileService = async (
  tipo,
  file,
  kind = "tutorial",
) => {
  const formData = new FormData();
  formData.append("kind", kind);
  formData.append(fieldFile(kind), file);
  const response = await apiBase.patch(
    `v1/media/tutoriales/?tipo=${tipo}&kind=${kind}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return response.data;
};

export const patchMediaTutorialUrlService = async (
  tipo,
  url,
  kind = "tutorial",
) => {
  const response = await apiBase.patch(
    `v1/media/tutoriales/?tipo=${tipo}&kind=${kind}`,
    { [fieldUrl(kind)]: url, kind },
  );
  return response.data;
};

export const deleteMediaTutorialService = async (tipo, kind = null) => {
  const suffix = kind ? `&kind=${kind}` : "";
  const response = await apiBase.delete(
    `v1/media/tutoriales/?tipo=${tipo}${suffix}`,
  );
  return response.data;
};
